import { IconType } from 'components/Icon';
import Icon from 'components/Icon';
import { MenuItemAction } from 'menu/MenuItem';
import { useTheme } from 'styled-components';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { setActiveDsTab, setDsTabs, showContextMenu } from 'redux/mode/actions';
import AddTabButton from '../AddTabButton';
import DraggableTab from './DraggableTab';
import * as S from './styles';

const TabBar = () => {
	const dispatch = useDispatch();
	const theme = useTheme();

	const { dsTabs, activeDsTabId } = useSelector(
		(r: RootReducer) => ({
			dsTabs: r.mode.dsTabs,
			activeDsTabId: r.mode.activeDsTabId,
		}),
		shallowEqual
	);

	//----------------------------------------------------------------------
	// HANDLERS
	//----------------------------------------------------------------------

	const moveTab = (dragIndex: number, hoverIndex: number) => {
		if (dragIndex === hoverIndex) return;
		const reordered = [...dsTabs];
		const [removed] = reordered.splice(dragIndex, 1);
		reordered.splice(hoverIndex, 0, removed);
		dispatch(setDsTabs(reordered));
	};

	const onHomeContextMenu = (e: React.MouseEvent) => {
		if (dsTabs.length === 0) return;

		dispatch(
			showContextMenu({
				point: { x: e.clientX, y: e.clientY },
				menuItems: [
					new MenuItemAction('Close All Tabs', '', () => {
						dispatch(setDsTabs([]));
					}),
				],
			})
		);
	};

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------

	return (
		<S.Base>
			<S.TabBar>
				<S.HomeTab
					$active={activeDsTabId === null}
					onClick={() => dispatch(setActiveDsTab(null))}
					onContextMenu={onHomeContextMenu}
				>
					<S.TabIcon>
						<Icon type={IconType.HOME} width={14} height={14} color={theme.gray[900]} />
					</S.TabIcon>
					<S.TabLabel>Home</S.TabLabel>
				</S.HomeTab>
				{dsTabs.map((tab, index) => (
					<DraggableTab key={tab.id} tab={tab} index={index} moveTab={moveTab} />
				))}
			</S.TabBar>
			<S.AddTabButtonWrapper>
				<AddTabButton />
			</S.AddTabButtonWrapper>
		</S.Base>
	);
};

export default TabBar;
